import useSWR from 'swr'
import { getLidoStakingStats, getLidoApr } from '~/apis/lido'

/**
 * Hook to fetch Lido staking statistics and APR using SWR
 * @returns Object with apr, totalStaked, stakers, and error states
 */
export const useLidoStakingStats = () => {
  const { data: statsData, error: statsError } = useSWR(
    'lido-staking-stats',
    getLidoStakingStats,
    {
      refreshInterval: 60000,
    },
  )

  const { data: aprData, error: aprError } = useSWR(
    'lido-steth-apr',
    getLidoApr,
    {
      refreshInterval: 60000,
    },
  )

  // Format totalStaked to show with commas (e.g., "9,052,140")
  const formatNumber = (value: string | undefined) => {
    if (!value) return '~'
    const num = parseFloat(value)
    if (isNaN(num)) return '~'
    return num.toLocaleString('en-US', { maximumFractionDigits: 0 })
  }

  // Transform API response to formatted APR string
  const apr = aprData?.data?.smaApr ? `${aprData.data.smaApr.toFixed(1)}%` : '~'

  return {
    apr,
    totalStaked: formatNumber(statsData?.totalStaked),
    stakers: formatNumber(statsData?.uniqueAnytimeHolders),
    error: statsError || aprError,
  }
}
